import { render } from "./product-siblings.vue?vue&type=template&id=14dddda2"
import script from "./product-siblings.vue?vue&type=script&lang=js"
export * from "./product-siblings.vue?vue&type=script&lang=js"

import "./product-siblings.vue?vue&type=style&index=0&id=14dddda2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__